import React from 'react'

const TURNSTILE_SCRIPT_ID = 'turnstile-widget-script'
const TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

let turnstileScriptPromise = null

function loadTurnstileScript() {
  if (typeof window === 'undefined') return Promise.resolve(null)
  if (window.turnstile) return Promise.resolve(window.turnstile)

  if (turnstileScriptPromise) return turnstileScriptPromise

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID)
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.turnstile))
      existingScript.addEventListener('error', reject)
      return
    }

    const script = document.createElement('script')
    script.id = TURNSTILE_SCRIPT_ID
    script.src = TURNSTILE_SCRIPT_URL
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = reject
    document.head.appendChild(script)
  })

  return turnstileScriptPromise
}

class TurnstileCaptcha extends React.Component {
  constructor(props) {
    super(props)
    this.container = null
    this.widgetId = null
    this.unmounted = false

    this.setContainerRef = this.setContainerRef.bind(this)
    this.renderWidget = this.renderWidget.bind(this)
  }

  componentDidMount() {
    this.renderWidget()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey) {
      if (
        typeof window !== 'undefined' &&
        window.turnstile &&
        this.widgetId !== null
      ) {
        window.turnstile.reset(this.widgetId)
      }
    }
  }

  componentWillUnmount() {
    this.unmounted = true
    if (
      typeof window !== 'undefined' &&
      window.turnstile &&
      this.widgetId !== null
    ) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  async renderWidget() {
    const { siteKey, onError } = this.props
    if (!siteKey) return

    try {
      await loadTurnstileScript()
      if (this.unmounted || !this.container || !window.turnstile) return

      if (this.widgetId !== null) {
        window.turnstile.remove(this.widgetId)
      }

      this.widgetId = window.turnstile.render(this.container, {
        sitekey: siteKey,
        callback: token => {
          if (this.props.onVerify) this.props.onVerify(token)
        },
        'expired-callback': () => {
          if (this.props.onExpire) this.props.onExpire()
        },
        'error-callback': () => {
          if (onError) onError()
        },
      })
    } catch (e) {
      if (onError) onError()
    }
  }

  setContainerRef(node) {
    this.container = node
  }

  render() {
    if (!this.props.siteKey) {
      return (
        <p className="mb-0">
          Security check is currently unavailable. Please try again later.
        </p>
      )
    }

    return <div ref={this.setContainerRef}></div>
  }
}

export default TurnstileCaptcha
